// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__hsjml","main":"About_main__KwD6N","pink":"About_pink__PEb4I","green":"About_green__Mih4Z","emoji":"About_emoji__KRXL4","skills":"About_skills__RvndN"};